import { Alert } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LoginForm } from '@features/auth';
import { AuthLayout } from '@widgets/auth-layout';

interface LocationState {
  passwordResetSuccess?: boolean;
}

export function LoginPage() {
  const location = useLocation();
  const state = (location.state ?? {}) as LocationState;
  const [showResetSuccess, setShowResetSuccess] = useState(!!state.passwordResetSuccess);

  // Прячем подсказку через 8 секунд
  useEffect(() => {
    if (!showResetSuccess) return;
    const t = setTimeout(() => setShowResetSuccess(false), 8000);
    return () => clearTimeout(t);
  }, [showResetSuccess]);

  return (
    <AuthLayout>
      {showResetSuccess && (
        <Alert
          type="success"
          message="Пароль успешно изменён. Войдите с новым паролем."
          showIcon
          style={{ marginBottom: 16 }}
          closable
          onClose={() => setShowResetSuccess(false)}
        />
      )}
      <LoginForm />
    </AuthLayout>
  );
}
